import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const UNITS_ENDPOINT = "/unit_measure";

export class UnitMeasureService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE UNIDADES DE MEDIDA
     * @EN GETS THE LIST OF UNITS OF MEASURE
     */
    // -------------------------------------------------------------------------------------------------------------
    listUnits = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: UNITS_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA UNIDAD DE MEDIDA POR SU ID
     * @EN GETS A UNIT OF MEASURE BY ITS ID     
     */
    // -------------------------------------------------------------------------------------------------------------
    getUnitById = async (unitId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: UNITS_ENDPOINT + "/get",
            data: { id: unitId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLEA UNA UNIDAD DE MEDIDA
     * @EN TOGGLES A UNIT OF MEASURE
     */
    // -------------------------------------------------------------------------------------------------------------
    toggleUnitStatus = async (unitId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: UNITS_ENDPOINT + "/toggle",
            data: { id: unitId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UNA UNIDAD DE MEDIDA
     * @EN CREATES A UNIT OF MEASURE
     */
    // -------------------------------------------------------------------------------------------------------------
    createUnit = async (unit: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: UNITS_ENDPOINT + "/create",
            data: unit,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UNA UNIDAD DE MEDIDA
     * @EN EDITS A UNIT OF MEASURE
     */
    // -------------------------------------------------------------------------------------------------------------
    editUnit = async (unit: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: UNITS_ENDPOINT + "/edit",
            data: unit,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UNA UNIDAD DE MEDIDA
     * @EN DELETES A UNIT OF MEASURE
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteUnit = async (unitId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: UNITS_ENDPOINT + "/delete",
            data: { id: unitId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIAS UNIDADES DE MEDIDA
     * @EN DELETES MULTIPLE UNITS OF MEASURE
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiUnit = async (unitIds: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: UNITS_ENDPOINT + "/delete-multi",
            data: { 
                ids:unitIds
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE UNIDADES DE MEDIDA PARA UN SELECT
     * @EN GETS THE LIST OF UNITS OF MEASURE FOR A SELECT   
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: UNITS_ENDPOINT + "/list-select",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}